import React from 'react'

const ErrorFallback = <h1>Oops, something went wrong.</h1>

export default ErrorFallback
